import { defineStore } from 'pinia'
import http from '../api/http'

export const useUserStore = defineStore('user', {
  state: () => ({
    token: localStorage.getItem('xk_token') || '',
    user: JSON.parse(localStorage.getItem('xk_user') || 'null'),
    menus: JSON.parse(localStorage.getItem('xk_menus') || '[]'),
    factories: [],
    factoryId: localStorage.getItem('xk_factory') || ''
  }),
  getters: {
    role: s => s.user?.role || '',
    paths: s => s.menus.map(m => m.path),
    can: s => path => s.menus.some(m => m.path === path)
  },
  actions: {
    async login(form) {
      const data = await http.post('/auth/login', form)
      this.apply(data)
    },
    apply(data) {
      this.token = data.token || this.token
      this.user = data.user
      this.menus = data.menus || []
      this.ensureStoreOrders()
      this.factories = data.factories || this.factories
      if (data.token) localStorage.setItem('xk_token', data.token)
      localStorage.setItem('xk_user', JSON.stringify(this.user))
      localStorage.setItem('xk_menus', JSON.stringify(this.menus))
    },
    async refresh() {
      const data = await http.get('/auth/me')
      this.user = data.user
      this.menus = data.menus || []
      this.ensureStoreOrders()
      this.factories = data.factories || []
      localStorage.setItem('xk_user', JSON.stringify(this.user))
      localStorage.setItem('xk_menus', JSON.stringify(this.menus))
    },
    ensureStoreOrders() {
      if (this.user?.role !== 'STORE' || this.menus.some(m => m.path === '/orders')) return
      const item = { name: '订单管理', path: '/orders' }
      const at = this.menus.findIndex(m => m.path === '/intake')
      if (at >= 0) this.menus.splice(at, 0, item)
      else this.menus.push(item)
    },
    setFactory(id) {
      this.factoryId = id ? String(id) : ''
      if (this.factoryId) localStorage.setItem('xk_factory', this.factoryId)
      else localStorage.removeItem('xk_factory')
    },
    logout() {
      this.token = ''
      this.user = null
      this.menus = []
      localStorage.removeItem('xk_token')
      localStorage.removeItem('xk_user')
      localStorage.removeItem('xk_menus')
    }
  }
})
